import { NgModule } from '@angular/core';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import {UserPreferenceApiService} from './userpreference-api.service';

@NgModule({
  imports: [
    ConfigManagerModule
  ],
  providers: [
    UserPreferenceApiService,
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json'}},
  ]
})
export class SdkUserPreferenceModule { }
